module.exports = __webpack_public_path__ + "img/icon_google_pay.c8aac7b7.png";